/**
 * TrackVisible component
 *
 * @author    Matt Stanley<mastanley@wayfair.com>
 * @copyright 2018 Wayfair LLC - All rights reserved
 */
import React from 'react';
import PropTypes from 'prop-types';

export default class TrackVisible extends React.Component {
  static displayName = `TrackVisibility`;

  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.element])
      .isRequired,
    tracker: PropTypes.object.isRequired,
    data: PropTypes.object,
    type: PropTypes.string,
  };

  static defaultProps = {
    type: null,
    data: {},
  };

  // Client-side only tracking.
  // At this point in component's lifecycle all children should be mounted.
  componentDidMount() {
    const {tracker, type, data} = this.props;
    tracker.visibility.onVisible(() => {
      tracker.track({eventType: type, ...data});
    });
  }

  render() {
    return this.props.children;
  }
}
